var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAesmeDinline = function SvgAesmeDinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1092_13220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.354 5.642c-.665-1.288-.453-2.909-.453-2.923l-.77-.106-.772-.113c-.014.078-.234 1.72.368 3.311-5.32 2.173-8.845.97-10.359.163.68-1.641.446-3.396.432-3.474l-1.543.22s.213 1.634-.452 2.922l-.128.24C3.672 7.772.623 13.531 4.302 22.05l1.43-.616c-1.784-4.132-1.847-7.542-1.38-10.097 2.752.758 6.24 2.258 6.283 3.595.085 2.703.014 5.788.014 5.823l1.557.036s.07-3.043-.007-5.753c.559-1.585 4.047-3.014 6.601-3.708.474 2.562.41 5.965-1.38 10.104l1.43.616c3.679-8.52.63-14.279-.375-16.168l-.128-.24h.007Zm-6.82 7.62C10.053 11.437 6.48 10.29 4.72 9.81c.297-1.012.65-1.832.955-2.448 1.068.566 2.865 1.245 5.328 1.245 1.797 0 3.94-.36 6.417-1.387.319.63.708 1.5 1.026 2.597-1.634.439-5.2 1.578-6.913 3.453v-.007Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.177 5.705 1.068-.92-1.068-.927-1.068-.92v1.069H0v1.557h2.109v1.06l1.068-.919ZM23.166 4h-2.102V2.938l-1.075.92-1.069.927 1.069.92 1.075.92V5.564h2.102V4Z",
    fill: "#D9516C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1092_13220"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 2.5)",
    d: "M0 0h23.166v19.55H0z"
  })))));
};
export default SvgAesmeDinline;